var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.1834 7.04427C16.3084 3.19427 12.9501 1.46094 10.0001 1.46094C10.0001 1.46094 10.0001 1.46094 9.99175 1.46094C7.05008 1.46094 3.68341 3.18594 2.80841 7.03594C1.83341 11.3359 4.46675 14.9776 6.85008 17.2693C7.73341 18.1193 8.86675 18.5443 10.0001 18.5443C11.1334 18.5443 12.2667 18.1193 13.1417 17.2693C15.5251 14.9776 18.1584 11.3443 17.1834 7.04427Z",
    fill: "#FB4764"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99976 11.2188C11.4495 11.2188 12.6248 10.0435 12.6248 8.59375C12.6248 7.144 11.4495 5.96875 9.99976 5.96875C8.55001 5.96875 7.37476 7.144 7.37476 8.59375C7.37476 10.0435 8.55001 11.2188 9.99976 11.2188Z",
    fill: "#FB4764"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlace);
export default __webpack_public_path__ + "static/media/place.c4b7e4e7dd5c9bd6149e93bb3649ecdc.svg";
export { ForwardRef as ReactComponent };